/**
 * Put a request into the chat composer from outside the chat page.
 *
 * The pane lives in the AppShell, the composer in HomePage; neither owns
 * the other. A tile's Refresh dispatches `omni:compose` and the chat page,
 * when mounted, takes it (and calls `preventDefault` to say so). When it
 * is not mounted the caller navigates there with the text in router
 * state, which HomePage reads once on mount.
 *
 * Why fill the composer and not send: the person sees what will be asked
 * and on which tile, and a refresh is a turn on their budget — one
 * Enter, never a hidden turn.
 */

export const COMPOSE_EVENT = "omni:compose";

export interface ComposeDetail {
  text: string;
}

/** True when a mounted chat composer took the text. */
export function composeInChat(text: string): boolean {
  const event = new CustomEvent<ComposeDetail>(COMPOSE_EVENT, {
    detail: { text },
    cancelable: true,
  });
  return !window.dispatchEvent(event);
}

/**
 * The request a tile's Refresh puts in the composer. It names the tile id
 * so the agent replaces that tile (`core.pane_mount(tile_id=…)`) instead
 * of adding a second one.
 */
export function refreshRequest(tile: { id: string; title: string }, refresh: string): string {
  const name = tile.title ? `"${tile.title}"` : "this";
  return `Update the ${name} tile on my pane: ${refresh} (tile_id ${tile.id})`;
}
